import React, { useEffect } from "react";
import styled from "styled-components";
import Auxiliary from "util/Auxiliary";
import ModuleBreadcrumb from "components/Common/ModuleBreadcrumb";
import { Col, Row } from "antd";
import AttendanceViewCard from "./AttendanceViewCard";
import { useDispatch, useSelector } from "react-redux";
import {
  getAttendanceDataSelector,
  getTotalUsers,
} from "../../../appRedux/selectors/User";
import {
  requestAttendanceGet,
  requestUserDetails,
} from "../../../appRedux/actions/User";
import { useMemo } from "react";

const ViewAttendance = () => {
  const AttDetails = useSelector(getAttendanceDataSelector);
  const total = useSelector(getTotalUsers);
  const dispatch = useDispatch();

  const initialParams = useMemo(() => {
    return {
      page: 1,
      limit: 10,
      q: "",
    };
  }, []);

  useEffect(() => {
    dispatch(requestAttendanceGet({ id: "", date: "" }));
    dispatch(requestUserDetails(initialParams));
  }, [initialParams]);

  return (
    <AttendanceStyle>
      <Auxiliary>
        <ModuleBreadcrumb
          title="Nikol Bal-Sabha Attendance"
          breadcrumbs={["Attendance", "View"]}
          links={["/attendance", "/attendance", ""]}
        />
        <Row className="gx-profile-content">
          <Col span={24}>
            <div className="gx-card">
              <div className="gx-card-body">
                {AttDetails &&
                  AttDetails.length &&
                  AttDetails.map((data) => (
                    <AttendanceViewCard
                      data={data}
                      total={total}
                      button="view"
                    />
                  ))}
              </div>
            </div>
          </Col>
        </Row>
      </Auxiliary>
    </AttendanceStyle>
  );
};

const AttendanceStyle = styled.div``;

export default ViewAttendance;
